<div [class.td-wb-modal-content--sub-modal-opened]="subModal() !== undefined"
     [attr.inert]="subModal() !== undefined || null">
  <ng-template #portalOutlet
               cdkPortalOutlet />
</div>
@if (subModal() !== undefined) {
  <div>
    <ng-container [cdkPortalOutlet]="subModal()" />
  </div>
}

